import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "src/componentes";
import {
  UsuarioConfirmarEmail,
  UsuarioEnviarConfirmacaoEmail,
} from "src/services/Identity.Service";

export const ConfirmarEmailCode = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState<string>("");
  const [codigo, setCodigo] = useState<string>("");
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [resending, setResending] = useState<boolean>(false);
  const [timeLeft, setTimeLeft] = useState<number>(180); // 3 minutos = 180s
  const [isEditingEmail, setIsEditingEmail] = useState<boolean>(false);

  useEffect(() => {
    const stateEmail = location.state?.email;
    if (stateEmail) {
      setEmail(stateEmail);
    } else {
      setIsEditingEmail(true);
    }
  }, [location.state]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft === 180]); // Reinicia o timer sempre que for resetado para 180

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      showToast({
        message: "Por favor, digite seu e-mail.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    if (!codigo || codigo.length !== 6) {
      showToast({
        message: "Por favor, insira o código de 6 dígitos.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    setSubmitting(true);
    try {
      const response = await UsuarioConfirmarEmail(email, codigo);
      if (response.success) {
        showToast({
          message: "E-mail confirmado com sucesso! Faça seu login.",
          variant: "Success",
        });
        navigate("/login");
      } else {
        showToast({
          message: response.notifications[0]?.message || "Código inválido ou expirado.",
          title: "Erro",
          variant: "Warning",
        });
      }
    } catch (error) {
      console.error("Erro ao confirmar e-mail:", error);
      showToast({
        message: "Ocorreu um erro ao verificar o código.",
        title: "Erro",
        variant: "Warning",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    if (timeLeft > 0) return;
    if (!email) {
      showToast({
        message: "Por favor, informe seu e-mail para reenviar.",
        title: "Aviso",
        variant: "Warning",
      });
      return;
    }

    setResending(true);
    try {
      const response = await UsuarioEnviarConfirmacaoEmail({ email } as any);
      if (response.success) {
        showToast({
          message: "Novo código de confirmação enviado para o e-mail!",
          variant: "Info",
        });
        setTimeLeft(180);
      } else {
        showToast({
          message: response.notifications[0]?.message || "Erro ao reenviar o e-mail.",
          title: "Erro",
          variant: "Warning",
        });
      }
    } catch (error) {
      console.error("Erro ao reenviar e-mail:", error);
      showToast({
        message: "Ocorreu um erro ao reenviar o e-mail.",
        title: "Erro",
        variant: "Warning",
      });
    } finally {
      setResending(false);
    }
  };

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  return {
    email,
    setEmail,
    codigo,
    setCodigo,
    submitting,
    resending,
    timeLeft,
    formatTime,
    onSubmit,
    handleResend,
    onClickNavigate,
    isEditingEmail,
    setIsEditingEmail,
  };
};
